import { useContext } from 'react';

import { OnboardingContext } from './onboarding.context';

export const useOnboardingContext = () => {
  return useContext(OnboardingContext);
};
